var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5C9.1 4.5 10 3.6 10 2.5C10 1.4 9.1 0.5 8 0.5C6.9 0.5 6 1.4 6 2.5C6 3.6 6.9 4.5 8 4.5ZM4.3 7.9L1.74 20.81C1.61 21.42 2.09 22 2.72 22H2.8C3.27 22 3.67 21.68 3.78 21.22L5.4 14L7.5 16V21C7.5 21.55 7.95 22 8.5 22C9.05 22 9.5 21.55 9.5 21V15.36C9.5 14.81 9.28 14.29 8.88 13.91L7.4 12.5L8 9.5C9.07 10.74 10.62 11.63 12.36 11.91C12.96 12 13.5 11.52 13.5 10.91C13.5 10.42 13.14 10.01 12.65 9.93C11.13 9.68 9.87 8.78 9.2 7.6L8.2 6C7.64 5.11 6.52 4.75 5.55 5.16L1.72 6.78C0.98 7.1 0.5 7.82 0.5 8.63V11C0.5 11.55 0.95 12 1.5 12C2.05 12 2.5 11.55 2.5 11V8.6L4.3 7.9Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkIcon);
export default __webpack_public_path__ + "static/media/WalkIcon.4daafbe0802181f1b6fcbdcf0ada3573.svg";
export { ForwardRef as ReactComponent };